import * as React from "react";
import { styled, Tooltip, tooltipClasses, TooltipProps } from "@mui/material";
import { observer } from "mobx-react";

const CustomWidthTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))({
  [`& .${tooltipClasses.arrow}`]: {
    color: "#394b59",
  },
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth: 500,
    backgroundColor: "#394b59",
  },
});

interface Props {
  text: JSX.Element
}

@observer
export default class CustomTooltip extends React.Component<Props, {}> {

  render(): React.ReactNode {
    return (<CustomWidthTooltip arrow title={this.props.text}>{this.props.text}</CustomWidthTooltip>)
  }

}